import http from '../http'
import Qs from 'qs'

// 教师信息分页列表
const getPageSysTeacher = (params) =>
  http
    .post('/theUserIdentity/sysTeacherInfoExs/pageSysTeacher', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 教育局学期师资统计
const getSysTeachersStatistics = (params) =>
  http
    .post('/theUserIdentity/sysTeacherInfoExs/teachersStatistics', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 老师详情
const getSysTeacherInfo = (params) =>
  http
    .get('/theUserIdentity/sysTeacherInfoExs/getSysTeacherInfo', { params })
    .then((res) => res.data)

// 修改教师信息
const updateSysTeacher = (params) =>
  http
    .post('/theUserIdentity/sysTeacherInfoExs/updateSysTeacher', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 查询老师服务学校
const getPageTermTeacherTaughtSchool = (params) =>
  http
    .post(
      '/theUserIdentity/sysTeacherInfoExs/pageTermTeacherTaughtSchool',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data)

// 查询老师任教班级
const getPageTermTeacherTeachClass = (params) =>
  http
    .post(
      '/theUserIdentity/sysTeacherInfoExs/pageTermTeacherTeachClass',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data)
// 导出-教师信息列表(运营端)
const exportSysTeacher = (params) =>
  http
    .get('/theUserIdentity/sysTeacherInfoExs/exportSysTeacher', {
      params,
      responseType: 'blob'
    })
    .then((res) => res)
// 获取基础平台老师分页列表
const searchTeachersList = (params) =>
  http
    .post('/theUserIdentity/sysTeacherInfoExs/searchTeachers', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 批量添加教师
const batchAddSysTeacher = (params) =>
  http
    .post('/theUserIdentity/sysTeacherInfoExs/batchAddSysTeacher', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)

// 查询学期已存在的教师
const queryExistingTeachers = (params) =>
  http
    .post('/theUserIdentity/sysTeacherInfoExs/queryExistingTeachers', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)
// 移除老师
const removeSysTeacher = (params) =>
  http
    .get('/theUserIdentity/sysTeacherInfoExs/removeTeacher', { params })
    .then((res) => res.data)

export default {
  getPageSysTeacher,
  getSysTeachersStatistics,
  getSysTeacherInfo,
  updateSysTeacher,
  getPageTermTeacherTaughtSchool,
  getPageTermTeacherTeachClass,
  exportSysTeacher,
  searchTeachersList,
  batchAddSysTeacher,
  queryExistingTeachers,
  removeSysTeacher
}
